"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@uirouter/core");
var actions_1 = require("./actions");
/** @hidden */
var hookResult = true;
/** @hidden */
var noop = function () { };
/**
 * Dispatch Redux event
 *
 * Creates a function that when called dispatches a Redux action with the transition info.
 *
 * @param event The event name
 * @param store The redux store
 * @param trans The Transition
 */
function dispatch(event, store, trans) {
    return function () {
        store.dispatch({ type: event, transition: trans });
    };
}
function handleTransitionError(trans, store) {
    return function (err) {
        var dispatcher;
        if (err.type === core_1.RejectType.SUPERSEDED && err.redirected === true) {
            dispatcher = dispatch(actions_1.REDIRECTED_TRANSITION, store, trans);
        }
        else if ((err.type = core_1.RejectType.IGNORED)) {
            dispatcher = dispatch(actions_1.IGNORED_TRANSITION, store, trans);
        }
        else {
            dispatcher = noop;
        }
        dispatcher();
    };
}
/**
 * Applies hooks to Transitions
 *
 * Registers hooks for every Transition and dispatches Redux events to sync it.
 *
 * @param router The Router instance
 * @param store The Redux store
 * @returns A function for removing the event listeners
 */
function applyHooks(router, store) {
    var transitionService = router.transitionService;
    var removeHooksFunctions = [];
    var removeMainHook = transitionService.onBefore({}, function (trans) {
        // Create a hook for the ends of the transition
        var dispatchOnStart = dispatch(actions_1.START_TRANSITION, store, trans);
        var dispatchOnFinish = dispatch(actions_1.FINISH_TRANSITION, store, trans);
        var dispatchOnSuccess = dispatch(actions_1.SUCCESS_TRANSITION, store, trans);
        removeHooksFunctions.push(trans.onStart({}, dispatchOnStart));
        removeHooksFunctions.push(trans.onFinish({}, dispatchOnFinish));
        removeHooksFunctions.push(trans.onSuccess({}, dispatchOnSuccess));
        trans.promise.then(noop, handleTransitionError(trans, store));
    });
    return function () {
        removeMainHook();
        removeHooksFunctions.forEach(function (fn) { return fn(); });
    };
}
exports.applyHooks = applyHooks;
//# sourceMappingURL=applyHooks.js.map